<style scoped>
.d-text {
  font-size: 1.5rem;
  vertical-align: middle;
}
</style>

<template>
  <div>
    <div class="mx-5">
      <v-row>
        <v-col cols="12" sm="12" lg="6" class="mb-n10 mt-n6">
          <v-autocomplete
            :items="ss_data"
            solo
            v-model="ss"
            dense
            item-text="NAME"
            item-value="ID"
            @change="c_season()"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" lg="3">
          <v-row>
            <v-col cols="12" sm="12" lg="12" style="text-align: center">
              <v-card elevation="3">
                <v-card-title>
                  <v-col cols="3">
                    <v-icon style="font-size: 3.5rem"
                      >mdi-human-male-female</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">จำนวนลงทะเบียน</span>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text"
                          >{{ count_register | delimeter }} คน</span
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" lg="12" style="text-align: center">
              <v-card elevation="3">
                <v-card-title>
                  <v-col cols="3">
                    <v-icon style="font-size: 3.5rem">mdi-chart-line</v-icon>
                  </v-col>
                  <v-col cols="9">
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">คะแนนเฉลี่ย</span>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text"
                          >{{ avg_score | delimeter }} / {{tt_avg_score}} คะแนน</span
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" lg="3">
          <v-row>
            <v-col cols="12" sm="12" lg="12" style="text-align: center">
              <v-card elevation="3">
                <v-card-title>
                  <v-col cols="3">
                    <v-icon style="font-size: 3.5rem"
                      >mdi-text-box-check-outline</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">ผ่านเกณฑ์</span>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">{{ pass | delimeter }} คน</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" lg="12" style="text-align: center">
              <v-card elevation="3">
                <v-card-title>
                  <v-col cols="3">
                    <v-icon style="font-size: 3.5rem"
                      >mdi-text-box-remove-outline</v-icon
                    >
                  </v-col>
                  <v-col cols="9">
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">ไม่ผ่านเกณฑ์</span>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        lg="12"
                        style="text-align: center"
                      >
                        <span class="d-text">{{ failed | delimeter }} คน</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-card elevation="3">
            <v-card-title> ประเภทผู้ลงทะเบียน </v-card-title>
            <v-card-text>
              <Doughnut
                :styles="myStyles"
                :chartData="piechart_ptype"
              ></Doughnut>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" lg="6">
          <v-card elevation="3">
            <v-card-title> คะแนนเฉลี่ยรายสัปดาห์ </v-card-title>
            <v-card-text>
              <LineChart
                :styles="myStyles"
                :chartData="weeklyScoreData"
              ></LineChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-card elevation="3">
            <v-card-title> แปรผลภาวะลงพุงตามประเภทผู้ลงทะเบียน </v-card-title>
            <v-card-text>
              <BarChart :styles="myStyles" :chartData="person_ms"></BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" lg="6">
          <v-card elevation="3">
            <v-card-title> ประเภทความพิการ </v-card-title>
            <v-card-text>
              <Doughnut
                :styles="piechart_style"
                :chartData="HandiTypeData"
              ></Doughnut>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="3">
          <v-card elevation="3">
            <v-card-title> แปรผล BMI ก่อนเริ่มกิจกรรม</v-card-title>
            <v-card-text>
              <PieChart :styles="myStyles" :chartData="PostBmiData"></PieChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="3">
          <v-card elevation="3">
            <v-card-title> แปรผล BMI หลังทำกิจกรรม</v-card-title>
            <v-card-text>
              <PieChart :styles="myStyles" :chartData="PieChart3"></PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/BarChart";
import Doughnut from "@/components/DoughNut";
import PieChart from "@/components/PieChart";
import LineChart from "@/components/LineChart";
import moment from "moment";
export default {
  name: "dashboard",
  components: {
    Doughnut,
    PieChart,
    LineChart,
    BarChart,
  },
  data() {
    return {
      height: 200,
      count_register: 0,
      avg_score: 0,
      ss: null,
      ss_data: [],
      pass: 0,
      failed: 0,
      piechart_ptype: [],
      HandiTypeData: [],
      PostBmiData: [],
      PieChart3: [],
      tt_avg_score:0,
      weeklyScoreData: [],
      person_ms: [],
    };
  },
  created() {
    this.initialApi();
  },
  filters: {
    delimeter(data) {
      if (!isNaN(parseFloat(data))) {
        let y = parseFloat(data).toFixed(0);
        let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return x;
      } else {
        return 0;
      }
    },
    formatDate(data) {
      return moment(data).locale("th").add(543, "Y").format("LL");
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
    piechart_style() {
      return {
        height: `200px`,
        position: "relative",
      };
    },
  },
  methods: {
    back() {
      this.$router.push({ path: "/" });
    },
    initialApi() {
      this.$token_api
        .get("/get-season-data")
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.ss_data = result;
            this.get_current_season();
            
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    get_current_season() {
      this.$token_api
        .get("/list-season-week")
        .then((res) => {
          const result2 = res.data.data;
          this.ss = result2.Season || 4;
          this.tt_avg_score = this.ss >= 10 ? 637 : 280
          this.api_avg_score();
          this.api_evaluate_score();
          this.api_linechart_weekly();
          this.api_post_bmi();
          this.api_post_bmi_end();
          this.api_count_register();
          this.api_count_haditype();
          this.api_count_person_type();
          this.api_count_person_ms();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    c_season() {
      this.api_avg_score();
      this.api_evaluate_score();
      this.api_linechart_weekly();
      this.api_post_bmi();
      this.api_post_bmi_end();
      this.api_count_register();
      this.api_count_haditype();
      this.api_count_person_type();
      this.api_count_person_ms();
      this.tt_avg_score = this.ss >= 10 ? 637 : 280
    },
    api_count_person_type() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            backgroundColor: ["#039BE5", "#64DD17", "#FF9800"],
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/piechart-persontype/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push(result[index].P_TYPE);
              _dataSet.datasets[0].data.push(result[index].CP_TYPE);
            }
            this.piechart_ptype = _dataSet;
          } else {
            this.piechart_ptype = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_count_haditype() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#00BCD4",
              "#03A9F4",
              "#039BE5",
              "#64DD17",
              "#76FF03",
              "#FF9800",
              "#FFAB00",
              "#FDD835",
            ],
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/piechart-handitype/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push(result[index].HANDI_TYPE);
              _dataSet.datasets[0].data.push(result[index].C_HANDI);
            }
            this.HandiTypeData = _dataSet;
          } else {
            this.HandiTypeData = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_count_person_ms() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            label: "ลงพุง",
            backgroundColor: "#64DD17",
            data: [],
          },
          {
            label: "ไม่ลงพุง",
            backgroundColor: "#FF9800",
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/count-person-ms/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push(result[index].P_TYPE); //
              _dataSet.datasets[0].data.push(result[index].R_FAT);
              _dataSet.datasets[1].data.push(result[index].R_NORMAL);
            }
            this.person_ms = _dataSet;
          } else {
            this.person_ms = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_count_register() {
      this.$token_api
        .get(`/count-register/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.count_register = result[0].C_PERSON;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_post_bmi() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#039BE5",
              "#64DD17",
              "#FF9800",
              "#EC407A",
              "#D50000",
            ],
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/piechart-post-bmi/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push(result[index].RESULT); //
              _dataSet.datasets[0].data.push(result[index].C_RESULT);
            }
            this.PostBmiData = _dataSet;
          } else {
            this.PostBmiData = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    api_post_bmi_end() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#039BE5",
              "#64DD17",
              "#FF9800",
              "#EC407A",
              "#D50000",
            ],
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/piechart-post-bmi-end/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push(result[index].RESULT); //
              _dataSet.datasets[0].data.push(result[index].C_RESULT);
            }
            this.PieChart3 = _dataSet;
          } else {
            this.PieChart3 = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },



    api_avg_score() {
      this.$token_api
        .get(`/avg-score/${this.ss}/ทั้งหมด`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.avg_score = result[0].AVG_SCORE;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_linechart_weekly() {
      let _dataSet = {
        labels: [],
        datasets: [
          {
            label: "คะแนน",
            fill: false,
            borderColor: "rgb(75, 192, 192)",
            data: [],
          },
        ],
      };
      this.$token_api
        .get(`/linechart-weekly/${this.ss}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              _dataSet.labels.push("สัปดาห์ " + result[index].WEEKS);
              _dataSet.datasets[0].data.push(result[index].AVG_SCORE);
            }
            this.weeklyScoreData = _dataSet;
          } else {
            this.weeklyScoreData = _dataSet;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_evaluate_score() {
      this.pass = 0;
      this.failed = 0;
      this.$token_api
        .get(`/evaluate-score/${this.ss}/ทั้งหมด`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              if (result[index].RESULT == "ผ่าน") {
                this.pass = result[index].TOTAL_RESULT;
              } else {
                this.failed = result[index].TOTAL_RESULT;
              }
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
